
    <template>
      <section class="relax-doc">
        <h1>Input 输入框</h1>
<blockquote>
<p>通过鼠标或键盘输入内容，是最基础的表单域的包装</p>
</blockquote>
<h2 id="yan-shi"><a class="header-anchor" href="#yan-shi"></a> 演示</h2>
<blockquote>
<p>使用 <code>v-model</code> 实现数据的双向绑定</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo0 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-input placeholder=&quot;请输入&quot; type=&quot;text&quot; v-model=&quot;value&quot; /&gt;
  &lt;x-input placeholder=&quot;请输入&quot; type=&quot;password&quot; v-model=&quot;value&quot; style=&quot;margin-left:5px&quot; /&gt;
  &lt;div style=&quot;margin-top: 10px&quot;&gt;
    输入框值：{{value}}
  &lt;/div&gt;
&lt;/template&gt;

&lt;script&gt;
import {ref} from 'vue'
export default {
  setup(){
    const value = ref('')

    return {
      value
    }
  }
}
&lt;/script&gt;
</code></pre></template></demo-block><h2 id="jin-yong"><a class="header-anchor" href="#jin-yong"></a> 禁用</h2>
<blockquote>
<p>通过 <code>disabled</code> 属性指定是否禁用 input 组件</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo1 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-input placeholder=&quot;请输入&quot; type=&quot;text&quot; disabled /&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="qian-zhui-he-hou-zhui-tu-biao"><a class="header-anchor" href="#qian-zhui-he-hou-zhui-tu-biao"></a> 前缀和后缀图标</h2>
<blockquote>
<p>通过设置 <code>icon-before</code> 和 <code>icon-after</code> 设置前缀及后缀图标</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo2 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-input placeholder=&quot;请输入&quot; icon-before=&quot;x-icon-search&quot; /&gt;
  &lt;x-input placeholder=&quot;请输入&quot; icon-after=&quot;x-icon-calendar&quot; style=&quot;margin-left:5px&quot; /&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="ke-qing-kong"><a class="header-anchor" href="#ke-qing-kong"></a> 可清空</h2>
<blockquote>
<p>通过设置 <code>clearable</code> 可以开启输入框的清空</p>
</blockquote>
<demo-block>
        
        <template #source><element-demo3 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-input placeholder=&quot;请输入&quot; clearable /&gt;
&lt;/template&gt;
</code></pre></template></demo-block><h2 id="wen-ben-yu"><a class="header-anchor" href="#wen-ben-yu"></a> 文本域</h2>
<blockquote>
<p>设置 <code>type</code> 属性为 <code>textarea</code></p>
</blockquote>
<demo-block>
        <p><code>maxlength</code> 可以限制 <code>textarea</code> 的输入长度</p>

        <template #source><element-demo4 /></template>
        <template #highlight><pre v-pre><code class="html">&lt;template&gt;
  &lt;x-input placeholder=&quot;请输入&quot; style=&quot;width: 350px&quot; type=&quot;textarea&quot; rows=&quot;7&quot; cols=&quot;20&quot; :maxlength=&quot;40&quot; /&gt;
&lt;/template&gt;

</code></pre></template></demo-block>
      </section>
    </template>
    <script>
      import hljs from 'highlight.js'
      import * as Vue from "vue"
      export default {
        name: 'component-doc',
        components: {
          "element-demo0": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, toDisplayString: _toDisplayString, createElementVNode: _createElementVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_input = _resolveComponent("x-input")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_input, {
      placeholder: "请输入",
      type: "text",
      modelValue: _ctx.value,
      "onUpdate:modelValue": $event => ((_ctx.value) = $event)
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createVNode(_component_x_input, {
      placeholder: "请输入",
      type: "password",
      modelValue: _ctx.value,
      "onUpdate:modelValue": $event => ((_ctx.value) = $event),
      style: {"margin-left":"5px"}
    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
    _createElementVNode("div", { style: {"margin-top":"10px"} }, " 输入框值：" + _toDisplayString(_ctx.value), 1)
  ], 64))
}
  
    
        const {ref} = Vue
        
const democomponentExport = {
  setup(){
    const value = ref('')

    return {
      value
    }
  }
}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo1": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_input = _resolveComponent("x-input")

  return (_openBlock(), _createBlock(_component_x_input, {
    placeholder: "请输入",
    type: "text",
    disabled: ""
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo2": (function() {
    
    const { resolveComponent: _resolveComponent, createVNode: _createVNode, Fragment: _Fragment, openBlock: _openBlock, createElementBlock: _createElementBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_input = _resolveComponent("x-input")

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_x_input, {
      placeholder: "请输入",
      "icon-before": "x-icon-search"
    }),
    _createVNode(_component_x_input, {
      placeholder: "请输入",
      "icon-after": "x-icon-calendar",
      style: {"margin-left":"5px"}
    })
  ], 64))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo3": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_input = _resolveComponent("x-input")

  return (_openBlock(), _createBlock(_component_x_input, {
    placeholder: "请输入",
    clearable: ""
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),"element-demo4": (function() {
    
    const { resolveComponent: _resolveComponent, openBlock: _openBlock, createBlock: _createBlock } = Vue

function render (_ctx, _cache) {
  const _component_x_input = _resolveComponent("x-input")

  return (_openBlock(), _createBlock(_component_x_input, {
    placeholder: "请输入",
    style: {"width":"350px"},
    type: "textarea",
    rows: "7",
    cols: "20",
    maxlength: 40
  }))
}
  
    const democomponentExport = {}
    return {
      mounted(){
        this.$nextTick(()=>{
          const blocks = document.querySelectorAll('pre code:not(.hljs)')
          Array.prototype.forEach.call(blocks, hljs.highlightBlock)
        })
      },
      render,
      ...democomponentExport
    }
  })(),
        }
      }
    </script>
  